/*
  TOP用（の想定）のファーストビューの全画面動画のサイズや位置の調整をします。
  あと、動画音声の切り替え機能付きです。
  ボタンの画像のパスも変えます。

  パ
*/

export default class FirstviewVideo {
  constructor() {
    this.viewportWidth = window.innerWidth;
    this.viewportHeight = window.innerHeight;
    this.orientation = this.viewportWidth / this.viewportHeight < 1 ? 'portrait' : 'landscape';
    this.viewportRatio = this.viewportHeight / this.viewportWidth;
    this.resolutionRatio = 0.5625;

    this.wrapper = document.getElementById('firstview');
    this.video = document.getElementById('firstview_video');
    this.muteTriggerBtn = document.getElementById('sound_trigger');

    if(this.viewportWidth >= 769) {
      this.wrapper.style.height = this.viewportWidth > 1024
      ? `${this.viewportHeight - 36/* padding */}px`
      : `${this.viewportHeight - 18/* padding */}px`;
      this.adjustVideoSize();
    }

    window.addEventListener('resize', () => {
      let winWidth = window.innerWidth;

      if(winWidth >= 769) {
        this.viewportWidth = window.innerWidth;
        this.viewportHeight = window.innerHeight;
        this.orientation = this.viewportWidth / this.viewportHeight < 1 ? 'portrait' : 'landscape';
        this.viewportRatio = this.viewportHeight / this.viewportWidth;
        this.adjustVideoSize();

      } else {
        this.wrapper.removeAttribute('style')
        this.video.removeAttribute('style')
      }
    });

    this.muteTriggerBtn.addEventListener('click', () => {
      this.muteTrigger();
    });
  }

  soundModeIconPath(pathSuffix) {
    return `/_assets/images/top/icon_sound-${pathSuffix}.svg`;
  }

  muteTrigger() {
    this.video.muted = this.video.muted ? false : true;
    const pathSuffix = this.video.muted ? 'mute' : 'unmute';
    this.muteTriggerBtn.children[0].setAttribute('src', `${this.soundModeIconPath(pathSuffix)}`);
  }

  adjustVideoSize() {
    this.video.style.width = `${this.videoWidth()}px`;
    this.video.style.height = `${this.videoHeight()}px`;
  }

  videoWidth() {
    // ウィンドウ比率が動画の比率 0.5625 より小さい(幅広)
    if (this.viewportRatio <= this.resolutionRatio) {
      return this.viewportWidth;
    }
    // ウィンドウ比率が動画の比率 0.5625 より大きい(縦長)
    if (this.viewportRatio > this.resolutionRatio) {
      return this.viewportHeight / this.resolutionRatio;
    }
  }

  videoHeight() {
    // ウィンドウ比率が動画の比率 0.5625 より小さい(幅広)
    if (this.viewportRatio <= this.resolutionRatio) {
      return this.viewportWidth * this.resolutionRatio;
    }
    // ウィンドウ比率が動画の比率 0.5625 より大きい(縦長)
    if (this.viewportRatio > this.resolutionRatio) {
      return this.viewportHeight;
    }
  }
}
